import { jsx as _jsx } from "react/jsx-runtime";
import { ClipType } from "@air/api/types";
import { memo, useCallback, useMemo, useState } from "react";
import { buildURL } from "react-imgix";
import { useSelector } from "react-redux";
import { getCloudFrontUrlFromImgixUrl } from "~/constants/cloudfront";
import { IMAGE_THEATER } from "~/constants/testIDs";
import { centralizedClipAssetsSelector, centralizedClipDescriptionSelector, centralizedClipTypeSelector } from "~/store/centralizedClip/selectors";
const DEFAULT_IMG_SIZE = 800;
export const MobileImageVisualizer = /*#__PURE__*/ memo(()=>{
    const clipAssets = useSelector(centralizedClipAssetsSelector);
    const description = useSelector(centralizedClipDescriptionSelector);
    const clipType = useSelector(centralizedClipTypeSelector);
    const [error, setError] = useState(false);
    const { src, fallbackUrl } = useMemo(()=>{
        const _src = clipType === ClipType.animated && clipAssets.video ? clipAssets.video : clipAssets.image;
        const _fallbackUrl = getCloudFrontUrlFromImgixUrl(_src);
        return {
            src: _src,
            fallbackUrl: _fallbackUrl
        };
    }, [
        clipAssets,
        clipType
    ]);
    const imgxUrl = useMemo(()=>{
        return buildURL(src, {
            w: DEFAULT_IMG_SIZE,
            h: DEFAULT_IMG_SIZE,
            auto: "compress"
        }, {
            src,
            disableSrcSet: true
        });
    }, [
        src
    ]);
    const onError = useCallback(()=>{
        setError(true);
    }, []);
    const imgClassName = "flex object-contain max-w-full max-h-full transform-origin-center";
    return /*#__PURE__*/ _jsx("div", {
        className: "flex size-full max-h-[calc(100vh-238px)] items-center justify-center",
        "data-testid": IMAGE_THEATER,
        children: !!error ? // eslint-disable-next-line @next/next/no-img-element
        /*#__PURE__*/ _jsx("img", {
            className: imgClassName,
            src: fallbackUrl,
            alt: description || ""
        }) : // eslint-disable-next-line @next/next/no-img-element
        /*#__PURE__*/ _jsx("img", {
            className: imgClassName,
            alt: description || "",
            src: imgxUrl,
            onError: onError
        })
    });
});
MobileImageVisualizer.displayName = "MobileImageVisualizer";
